import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from "@/components/ui/sonner";
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import OnboardingPage from './pages/OnboardingPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ProfilePage from './pages/ProfilePage';
import DashboardPage from './pages/DashboardPage';
import IntelligencePage from './pages/IntelligencePage';
import VoiceAgentPage from './pages/VoiceAgentPage';
import ConversationsPage from './pages/ConversationsPage';
import ConversationDetailPage from './pages/ConversationDetailPage';
import CustomersPage from './pages/CustomersPage';
import CustomerDetailPage from './pages/CustomerDetailPage';
import RemindersPage from './pages/RemindersPage';
import PrivacyPage from './pages/PrivacyPage';
import PrivacyLinkPage from './pages/PrivacyLinkPage';
import HelpPage from './pages/HelpPage';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { LiveEventsProvider } from './contexts/LiveEventsContext';
import { LiveOverviewProvider } from './contexts/LiveOverviewContext';
import { NotificationsProvider } from './contexts/NotificationsContext';
import { TransferNoticesProvider } from './contexts/TransferNoticesContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { SidebarProvider } from './contexts/SidebarContext';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        {/* One shared live-event stream for all authenticated pages (TopBar + Verläufe);
            it only connects while logged in, so public pages never open it. */}
        <LiveEventsProvider>
        {/* Above the router like the stream itself: the overview and the bell's
            chimes must survive page changes (Layout re-mounts per page). */}
        <LiveOverviewProvider>
        <NotificationsProvider>
        <TransferNoticesProvider>
        <Router>
          {/* Inside the router (auto-collapse follows the URL), above the routes:
              the sidebar state survives page changes although Layout re-mounts. */}
          <SidebarProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password/:businessId/:token" element={<ResetPasswordPage />} />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/intelligence"
              element={
                <ProtectedRoute>
                  <IntelligencePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/onboarding"
              element={
                <ProtectedRoute>
                  <OnboardingPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/voice-agent"
              element={
                <ProtectedRoute>
                  <VoiceAgentPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/conversations"
              element={
                <ProtectedRoute>
                  <ConversationsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/conversations/:id"
              element={
                <ProtectedRoute>
                  <ConversationDetailPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/customers"
              element={
                <ProtectedRoute>
                  <CustomersPage />
                </ProtectedRoute>
              }
            />
            {/* Mobile only — on desktop the profile renders inside CustomersPage. */}
            <Route
              path="/customers/:id"
              element={
                <ProtectedRoute>
                  <CustomerDetailPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reminders"
              element={
                <ProtectedRoute>
                  <RemindersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/privacy"
              element={
                <ProtectedRoute>
                  <PrivacyPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/help"
              element={
                <ProtectedRoute>
                  <HelpPage />
                </ProtectedRoute>
              }
            />
            <Route path="/agent-rules" element={<Navigate to="/voice-agent" replace />} />
            <Route path="/r/:token" element={<PrivacyLinkPage />} />
            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
          </SidebarProvider>
        </Router>
        </TransferNoticesProvider>
        </NotificationsProvider>
        </LiveOverviewProvider>
        </LiveEventsProvider>
        <Toaster />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
